import usePublicSearchContext from '@/publicSearch/store/usePublicSearchContext';
import { resolveAnimalQuickSearchDefaultOperator } from '@/components/publicSearch/search/animalQuickSearchDefault';

export function useAnimalQuickSearchDefaultOperator(): string {
  return usePublicSearchContext((context) =>
    resolveAnimalQuickSearchDefaultOperator(context.society.settings),
  );
}
